'use client';
export { Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map